import { Box, Button, useMediaQuery } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { When } from 'react-if'

import FAIcon from '../../../Theme/FAIcon'
import { FA_ICONS } from '../../../Theme/font-awesome-icon-constants'
import { BREAKPOINT_MIN_LG } from '../../../Theme/stylesUtil'
import { MapCard } from '../../_common/CollectionCard/MapCard'

const MapCardWrapper = ({ map, saveMapCardToFav, favoriteMaps, deleteMapCardFromFav, target, isOriginal }) => {
  const [showAddIcon, setShowIcon] = useState(false)

  const isAdded = useMemo(() => favoriteMaps.find((favMap) => favMap.id === map.id), [favoriteMaps, map])
  const isBiggerThanLGScreen = useMediaQuery(BREAKPOINT_MIN_LG)
  const showIcon = () => {
    if (!isBiggerThanLGScreen) return
    setShowIcon(true)
  }
  const closeIcon = () => {
    if (!isBiggerThanLGScreen) return
    setShowIcon(false)
  }
  useEffect(() => {
    if (!isBiggerThanLGScreen) {
      setShowIcon(true)
    }
  }, [isBiggerThanLGScreen])
  const handleClick = () => {
    if (isAdded) {
      return deleteMapCardFromFav(map, isOriginal)
    }
    saveMapCardToFav(map, isOriginal)
  }
  const isShowSaveButton = !isAdded && favoriteMaps.length === (isOriginal ? 3 : 4) && true
  return (
    <Box
      onMouseEnter={showIcon}
      onMouseLeave={closeIcon}
      sx={{ position: 'relative' }}
    >
      <MapCard
        map={map}
        style={{ height: '192px' }}
        target={target}
      />
      <When condition={showAddIcon}>
        <Button
          color={!!isAdded ? 'error' : 'secondary'}
          sx={{
            position: 'absolute',
            top: '5px',
            right: '5px',
            zIndex: '1000',
            backgroundColor: 'rgba(1, 163, 210, 0.1) !important',
            backdropFilter: 'blur(15px)',
          }}
          onClick={handleClick}
          disabled={isShowSaveButton}
        >
          <FAIcon
            iconClassName={!!isAdded ? FA_ICONS.CLOSE : FA_ICONS.PLUS}
            iconFontSize={18}
          />
        </Button>
      </When>
    </Box>
  )
}

export default MapCardWrapper
